import { Bitcoin, Mail, Linkedin, Facebook } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="border-t border-border bg-card mt-20">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-6 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <Bitcoin className="h-6 w-6 text-primary" />
              <span className="text-lg font-bold">BitcoinMind</span>
            </div>
            <p className="text-sm text-muted-foreground">
              Your AI Gateway to Everything Bitcoin. Powered by artificial intelligence.
            </p>
          </div>
          
          <div>
            <h3 className="font-semibold mb-4">Data & Analytics</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/bitcoin-treasuries" className="text-muted-foreground hover:text-primary transition-colors">Bitcoin Treasuries</Link></li>
              <li><Link to="/top-holders" className="text-muted-foreground hover:text-primary transition-colors">Top Holders</Link></li>
              <li><Link to="/onchain-metrics" className="text-muted-foreground hover:text-primary transition-colors">On-Chain Metrics</Link></li>
              <li><Link to="/lightning-network" className="text-muted-foreground hover:text-primary transition-colors">Lightning Network</Link></li>
              <li><Link to="/whale-alerts-preview" className="text-muted-foreground hover:text-primary transition-colors">Whale Alerts</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/news" className="text-muted-foreground hover:text-primary transition-colors">AI News</Link></li>
              <li><Link to="/learn" className="text-muted-foreground hover:text-primary transition-colors">Learn Bitcoin</Link></li>
              <li><Link to="/market" className="text-muted-foreground hover:text-primary transition-colors">Market Dashboard</Link></li>
              <li><Link to="/events" className="text-muted-foreground hover:text-primary transition-colors">Events</Link></li>
              <li><Link to="/jobs" className="text-muted-foreground hover:text-primary transition-colors">Jobs Board</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-semibold mb-4">Tools</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/dca-calculator" className="text-muted-foreground hover:text-primary transition-colors">DCA Calculator</Link></li>
              <li><Link to="/mining-calculator" className="text-muted-foreground hover:text-primary transition-colors">Mining Calculator</Link></li>
              <li><Link to="/portfolio" className="text-muted-foreground hover:text-primary transition-colors">Portfolio Tracker</Link></li>
              <li><Link to="/predict-market" className="text-muted-foreground hover:text-primary transition-colors">Predict Market</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-semibold mb-4">Resources</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/newsletter" className="text-muted-foreground hover:text-primary transition-colors">Newsletter</Link></li>
              <li><Link to="/about" className="text-muted-foreground hover:text-primary transition-colors">About Us</Link></li>
              <li><Link to="/contact" className="text-muted-foreground hover:text-primary transition-colors">Contact</Link></li>
              <li><Link to="/advertise" className="text-muted-foreground hover:text-primary transition-colors">Advertise</Link></li>
              <li><Link to="/premium" className="text-muted-foreground hover:text-primary transition-colors">Premium</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-semibold mb-4">Legal</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/faq" className="text-muted-foreground hover:text-primary transition-colors">FAQ</Link></li>
              <li><Link to="/terms-of-use" className="text-muted-foreground hover:text-primary transition-colors">Terms of Use</Link></li>
              <li><Link to="/terms-conditions" className="text-muted-foreground hover:text-primary transition-colors">Terms & Conditions</Link></li>
              <li><Link to="/refund-policy" className="text-muted-foreground hover:text-primary transition-colors">Refund Policy</Link></li>
              <li><Link to="/privacy-policy" className="text-muted-foreground hover:text-primary transition-colors">Privacy & Cookies</Link></li>
              <li><Link to="/security" className="text-muted-foreground hover:text-primary transition-colors">Security</Link></li>
              <li><Link to="/sitemap" className="text-muted-foreground hover:text-primary transition-colors">Sitemap</Link></li>
            </ul>
          </div>
        </div>
        
        {/* Security Badge */}
        <div className="border-t border-border mt-8 pt-6 text-center">
          <Link 
            to="/security" 
            className="inline-flex items-center gap-2 text-xs text-muted-foreground hover:text-primary transition-colors mb-3"
          >
            🔒 Site Security Verified — All systems monitored and encrypted
          </Link>
        </div>
      </div>
      
      {/* Footer Banner Ad */}
      <div className="border-t border-border bg-muted/30">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-center h-[90px] bg-card border border-border rounded-lg">
            <span className="text-xs text-muted-foreground">Footer Banner Ad (970x90) - Advertise Here</span>
          </div>
        </div>
      </div>
      
      {/* Connect Section Moved to Bottom */}
      <div className="bg-card border-t border-border">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-4">
              <span className="text-sm font-semibold">Connect:</span>
              <a href="https://x.com/bitcoinmindt" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors" aria-label="Follow us on X">
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
              </a>
              <a href="https://t.me/bitcoinmindt" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors" aria-label="Join us on Telegram">
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.65-.35-1.01.22-1.59.15-.15 2.71-2.48 2.76-2.69a.2.2 0 00-.05-.18c-.06-.05-.14-.03-.21-.02-.09.02-1.49.95-4.22 2.79-.4.27-.76.41-1.08.4-.36-.01-1.04-.2-1.55-.37-.63-.2-1.12-.31-1.08-.66.02-.18.27-.36.74-.55 2.92-1.27 4.86-2.11 5.83-2.51 2.78-1.16 3.35-1.36 3.73-1.36.08 0 .27.02.39.12.1.08.13.19.14.27-.01.06.01.24 0 .38z"/>
                </svg>
              </a>
              <a href="https://www.linkedin.com/company/bitcoinmind" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors" aria-label="Connect on LinkedIn">
                <Linkedin className="h-5 w-5" />
              </a>
              <a href="https://www.facebook.com/bitcoinmindt/" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors" aria-label="Like us on Facebook">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="mailto:contact@bitcoinmind.today" className="text-muted-foreground hover:text-primary transition-colors" aria-label="Email us">
                <Mail className="h-5 w-5" />
              </a>
            </div>
            <div className="text-center space-y-1">
              <p className="text-xs text-muted-foreground">
                © 2025 BitcoinMind.today - All content AI-generated
              </p>
              <p className="text-xs text-muted-foreground">
                🚧 Currently in Beta Testing - <Link to="/contact" className="underline hover:text-foreground">Share Your Feedback</Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
